import cookieconsent from 'cookieconsent';

const { description, link, dismiss } = rtwp.cookieconsent;
const data = {
  position: 'bottom',
  theme: 'default',
  layout: 'custom',
  layouts: {
    'custom': '<div class="profil-cookie">{{message}}{{link}}{{compliance}}</div>',
  },
  content: {
    message: description,
    dismiss,
    link: link ? link.title : '',
    href: link ? link.url : '',
    target: link ? link.target : '',
  }
};

window.cookieconsent.initialise(data);
